import JsonPrettyView from './JsonPrettyView'

export default JsonPrettyView
